module.exports = __webpack_public_path__ + "static/monitor-41a809c25d71023668b18b572e70ba52.png";